module.exports = __webpack_public_path__ + "img/1.add4a61a.jpg";